<template>
  <section class="px-4 py-12 md:py-16 bg-neutral-700">
    <div class="max-w-3xl mx-auto w-full flex flex-col items-center text-center">
      <h2>{{ t('landing.benefits.title') }}</h2>

      <div class="w-full mt-4 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          v-for="benefit in BENEFITS"
          :key="benefit"
          class="p-6 rounded-2xl bg-neutral-800 text-left flex flex-col gap-2"
        >
          <h3 class="mt-0 mb-0">{{ t(`landing.benefits.${benefit}.title`) }}</h3>
          <p class="text-neutral-300 mt-0 mb-0">{{ t(`landing.benefits.${benefit}.text`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const BENEFITS = ['audience', 'effort', 'numbers', 'risk'] as const
</script>
